import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { MediaPlaybackModule } from '@tytapp/media-playback';
import { HowToWatchComponent } from './how-to-watch/how-to-watch.component';
import { WatchPageComponent } from './watch-page/watch-page.component';
import { ShowsModule } from '@tytapp/shows';
import { LiveStreamsModule } from '@tytapp/live-streams';

@NgModule({
    declarations: [
        WatchPageComponent,
        HowToWatchComponent
    ],
    imports: [
        CommonModule,
        TYTCommonModule,
        CommonUiModule,
        ShowsModule,
        LiveStreamsModule,
        MediaPlaybackModule,
        MatButtonModule,
        MatIconModule,
        RouterModule.forChild([
            { path: 'how-to-watch', component: HowToWatchComponent },
            { path: 'edit', loadChildren: () => import('../video-editor-pages/video-editor-pages.module').then(m => m.VideoEditorPagesModule) },
            { path: 'shows/:show/:productionDate/:mode/:vod', component: WatchPageComponent },
            { path: ':show/:production/:mode/:vod', component: WatchPageComponent },
            { path: ':production/:mode/:vod', component: WatchPageComponent },
            { path: ':production/:mode', component: WatchPageComponent },
            { path: ':production', component: WatchPageComponent },
            { path: '', redirectTo: 'how-to-watch', pathMatch: 'full' }
        ])
    ]
})
export class WatchPagesModule {

}
